export enum EnvironmentName {
  LOCAL = 'Local',
  DEV = 'Dev',
  DEMO = 'Demo',
  NEW_FEATURE = 'New Feature',
  NEW_FEATURE_2 = 'New Feature 2',
  NEW_FEATURE_3 = 'New Feature 3',
  STAGING = 'Staging',
  STAGING_US = 'Staging - US',
  PRODUCTION_US = 'Production - US',
  PRODUCTION_LONDON = 'Production - London',
  PRODUCTION_SYDNEY = 'Production - Sydney',
  PRODUCTION_PROVET_US = 'Production Provet - US',
  V4P_PRODUCTION = 'V4P - Production',
  V4P_STAGING = 'V4P - Staging',
  GROOMROOM_PRODUCTION = 'Groomroom - Production',
  GROOMROOM_STAGING = 'Groomroom - Staging'
}
